import React, { useState } from 'react';
import './About.css';
import { useTranslation } from '../../i18n/TranslationContext';

interface AboutSection {
  key: string;
  icon: string;
  image?: string;
}

const aboutSections: AboutSection[] = [
  {
    key: 'history',
    icon: 'fas fa-history',
    image: '/img/Logo.webp'
  },
  {
    key: 'team',
    icon: 'fas fa-users',
    image: '/img/Logo.webp'
  },
  {
    key: 'commitment',
    icon: 'fas fa-medal',
    image: '/img/Logo.webp'
  }
];

const About: React.FC = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState<string>('history');
  
  const handleSectionClick = (key: string) => {
    setActiveSection(key);
  };

  const getActiveDetails = () => {
    if (activeSection === 'history') {
      return {
        title: t.about.history.title,
        content: t.about.history.content,
        image: aboutSections.find(s => s.key === activeSection)?.image || ''
      };
    } else if (activeSection === 'team') {
      return {
        title: t.about.team.title,
        content: t.about.team.content,
        image: aboutSections.find(s => s.key === activeSection)?.image || ''
      };
    } else {
      return {
        title: t.about.commitment.title,
        content: t.about.commitment.content,
        image: aboutSections.find(s => s.key === activeSection)?.image || ''
      };
    }
  };
  
  const activeDetails = getActiveDetails();
  
  return (
    <section id="about" className="about-section">
      <div className="about-glow"></div>
      <div className="container">
        <h2 className="section-title">{t.about.title}</h2>
        
        <div className="about-showcase">
          <div className="about-content-section">
            <div className="about-tabs">
              {aboutSections.map((section) => (
                <div 
                  key={section.key}
                  className={`about-tab ${activeSection === section.key ? 'active' : ''}`}
                  onClick={() => handleSectionClick(section.key)}
                >
                  <div className="about-tab-icon">
                    <i className={section.icon}></i>
                  </div>
                  <div className="about-tab-content">
                    <h3>
                      {section.key === 'history' && t.about.history.title}
                      {section.key === 'team' && t.about.team.title}
                      {section.key === 'commitment' && t.about.commitment.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="about-details glass-panel">
              <h3>{activeDetails.title}</h3>
              <p>{activeDetails.content}</p>
            </div>
          </div>
          
          <div className="about-image-section">
            <div className="image-container">
              <div className="image-overlay"></div>
              <div 
                className="image-bg" 
                style={activeDetails.image ? {backgroundImage: `url(${activeDetails.image})`} : undefined}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;